<template>
  <page-template id="addUser">

    <add-user-navbar @back="back" />

    <add-step1 v-if="active === 1" @continue="next" />
    <add-step2 v-if="active === 2" :user-form="userForm" />

  </page-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Logger } from 'oidc-client-ts';
import AddUserNavbar from './AddUserNavbar.vue';
import PageTemplate from '@/components/layout/PageTemplate.vue';
import { UserForm } from '@/views/Users/edit/index.vue';
import AddStep2 from './AddStep2.vue';
import AddStep1 from './AddStep1.vue';

export default defineComponent({
  name: 'AddUserPage',
  components: {
    AddUserNavbar, PageTemplate, AddStep1, AddStep2,
  },
  data: () => ({
    active: 1,
    userForm: {} as UserForm,
  }),
  methods: {
    next(form: UserForm) {
      this.userForm = form;
      this.active = 2;
    },
    back() {
      Logger.info('AddUser', 'back');
      if (this.active > 1) {
        this.active--;
      } else {
        this.goBack1Page();
      }
    },
  },
  mounted() {
    this.$toast.clear();
  },
});
</script>

<style>
</style>
